import React, { useEffect, useState } from 'react';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Pagination from '../../components/tables/pagination/Pagination';
import Button from '../../components/buttons/Button';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Breadcrumbs from '../../components/BreadCrumbs';
import { Link } from 'react-router-dom';
import { deleteCommnityApiCall, getCommunity } from '../../services/community';
import { BiCheck, BiCopy, BiEdit, BiRefresh, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { formatDate, formatDateTime } from '../../utils/FormatDateTime';
import Dropdown from '../../components/inputFields/DropDown';
import SearchBar from '../../components/searchBar/SearchBar';
import ConfirmModal from '../../components/popups/confirmationModal/ConfirmModal';
import { AiFillDelete } from 'react-icons/ai';
import { Edit } from '@mui/icons-material';
import { deleteMobilePopups, getMobilePopups, patchMobilePopups } from '../../services/mobile_popup';

function MobilePopups() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [typeFilterStatus, setTypeFilterStatus] = useState("");
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const pageSize = 10;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getMobilePopups(query || "");
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const [openingItem, setOpeningItem] = useState(null);
    const [modalIsDeleteOpen, setIsDeleteOpen] = useState(false);

    const openDeleteModal = (item) => {
        setOpeningItem(item);
        setIsDeleteOpen(true);
    };

    // Close modal
    const closeDeleteModal = () => {
        setIsDeleteOpen(false);
        setOpeningItem(null);
    };

    const deletePost = (isConfirmDelete) => {
        if (isConfirmDelete) {
            deleteCommunity(openingItem.id);
            closeDeleteModal();
        }
    };

    const deleteCommunity = async (forumId) => {
        try {
            let res = await deleteMobilePopups(forumId);
            if (res.status === 204) {
                fetchData("");
                closeDeleteModal();
                toast.success("Popup deleted successfully");
            } else {
                toast.error("Unable to delete Popup");
            }
        } catch (error) {
            console.error("Error deleting Popup:", error);
        }
    };

    const handleActive = async (item, value) => {
        try {
            let res = await patchMobilePopups({
                data: {
                    is_active: value,
                },
                id: item.id,
            });
            if (res.status === 200 || res.status === 201) {
                toast.success("Popup updated successfully");
                fetchData("");
            } else {
                toast.error("Unable to update Popup");
            }
        } catch (error) {
            console.error("Error Updating Popup:", error);
        }
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Marketing' },
            { name: 'Mobile Popups' },
        ]} />
        <div className="flex flex-row justify-between item-center">
            <div className="py-4 flex flex-row items-center gap-4">
                <StyledHeadingText text={"Mobile Popups (9:16)"} />
                {/* <SearchBar placeholder="Search Title..." onSearch={handleSearch} value={searchText} />
                <div className="min-w-40">
                    <Dropdown
                        name="status"
                        options={[
                            { label: "All", value: "" },
                            { label: "Mobile", value: "Mobile" },
                            { label: "Advertisement", value: "Advertisement" },
                            { label: "Dukaan", value: "Dukaan" },
                        ]}
                        value={typeFilterStatus}
                        placeholder={"Select Type"}
                        onChange={handleTypeFilterChange}
                    />
                </div>
                {
                    typeFilterStatus.length !== 0 || searchText !== "" ?
                        <BiRefresh size={24} className='cursor-pointer text-primary' onClick={resetFilters} /> : <></>
                } */}
            </div>
            <Link to="/marketing/mobile-pops/add" className='self-center'>
                <Button
                    type="button"
                    className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md"
                >
                    Add Popup
                </Button>
            </Link>
        </div>
        <>
            {
                loading ?
                    <div className="flex w-full flex-row justify-center my-2">
                        <CustomLoading size={100} />
                    </div>
                    :
                    <div className="mt-2 flex flex-row w-full gap-2">
                        <div className="max-w-full w-full">
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {data?.length > 0 ? (
                                    data.map((item, index) => (
                                        <div key={index} className="group h-full w-full aspect-square rounded-md border border-black relative">
                                            <img
                                                src={item.image ?? ""}
                                                alt={item.image ?? `Image ${index + 1}`}
                                                className={`rounded-md object-contain bg-black w-full h-full hover:scale-105 transition-transform duration-300 ${item.is_active ? "" : "grayscale"}`}
                                            />
                                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-b from-transparent to-black/60 rounded-md text-white p-2">
                                                {formatDateTime(item.created_at)}
                                            </div>

                                            {/* Top Overlay with Toggle and Icons */}
                                            <div className="absolute top-0 left-0 right-0 p-2 flex flex-row items-start justify-between rounded-md h-full">

                                                {/* Toggle Switch */}
                                                <label className="relative inline-flex items-center cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        checked={item.is_active}
                                                        onChange={(e) => handleActive(item, e.target.checked)}
                                                        className="sr-only peer"
                                                    />
                                                    <div className="w-11 h-6 bg-gray-300 peer-checked:bg-primary rounded-full transition-all duration-300" />
                                                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-all duration-300 peer-checked:translate-x-5" />
                                                </label>

                                                {/* Edit & Delete Icons */}
                                                <div className="flex opacity-0 group-hover:opacity-100 justify-end gap-4 transition-opacity duration-200">
                                                    <Link to="/marketing/mobile-pops/edit" state={item}>
                                                        <Edit className="text-primary cursor-pointer" size={16} />
                                                    </Link>
                                                    <BiTrash className="text-red-700 cursor-pointer" size={20} onClick={() => openDeleteModal(item)} />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No results found.</p>
                                )}
                            </div>
                            {/* {
                                data.count !== 0 ?
                                        <Pagination
                                            currentPage={currentPage}
                                            
                                            pageSize={pageSize}
                                            totalEntries={data?.count}
                                            onPageChange={handlePageChange}
                                            data={data}
                                            setData={setData}
                                        />: <></>
                            } */}
                        </div>
                    </div>
            }
        </>
        <ConfirmModal
            isOpen={modalIsDeleteOpen}
            onRequestClose={closeDeleteModal}
            contentLabel=""
            onClose={closeDeleteModal}
            setIsConfirmDelete={deletePost}
            title="Are you sure to Delete?"
            icon={<AiFillDelete color="red" size={50} />}
        />
    </>);
}

export default MobilePopups;